<template>
  <div class="guests-list-wrap" :style="`width: ${width};`">
    <ul class="guests-list" :style="`height: ${height};`">
      <li v-for="(item, index) in imgData" :class="`guests-item-${index}`" :style="`width: ${imgWidth}%`" :key="index" ref="slide">
        <i v-for="(sitem, sindex) in item"
        :style="`background-image: url(${urlPrefix}${sitem});`" :key="sindex"></i>
      </li>
      <li class="guests-list-more" v-if="Object.keys(more).length > 0" :style="`width: ${imgWidth}%`">
        <a :href="more.url" target="_blank"><i :style="`background-image: url(${urlPrefix}${more.image});`"></i></a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    urlPrefix: {//图片URL公共部分
      type: String
    },
    imgData: {//图片数据
      type: Array
    },
    rowNum: {//每行显示的数量
      type: Number,
      default: 4
    },
    width: {//容器宽度
      type: String,
      default: '100%'
    },
    height: {//容器高度
      type: String,
      default: '25.5vw'
    },
    more: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      preIndex: -1,
      timer: '',
      imgWidth: 0
    }
  },
  created() {
    this.imgWidth = parseFloat(100 / this.rowNum)
  },
  mounted() {
    // this.showList(this.imgData.length)
    this.timer = setInterval(this.animation, 3000)
  },
  methods: {
    showList(len) {
      let dom = this.$refs.slide
      let index = 0;
      let timer = setInterval(() => {
        if(index < len) {
          dom[index].style.opacity = 1
          dom[index].className = dom[index].className ? `${dom[index].className} li-show` : 'li-show'
          index++;
        }else {
          clearInterval(timer)
          clearInterval(this.timer)
          setTimeout(() => {
            this.timer = setInterval(this.animation, 3000)
          }, 200)
        }
      }, 400);
    },
    animation() {
      //指定列表项的随机索引
      let vm = this
      let index = this.randomNum(0, this.imgData.length - 1)
      //防止随机数等于上一个值
      while(index === this.preIndex) {
        index = vm.randomNum(0, this.$refs.slide.length - 1)
      }

      this.preIndex = index


      //指定选定项的随机
      let dom = this.$refs.slide[index]
      let active_index = -1, prev_index = -1, next_index = -1;
      for(let i = 0, len = dom.childNodes.length; i < len; i++) {
        let class_arr = dom.childNodes[i].className.split(' ');
        if(class_arr.includes('active')) {
          dom.childNodes[i].className = '';
          active_index = i;
          break;
        }
      }
      //设定classname
      let perNum = this.imgData[index].length - 1
      active_index = active_index === perNum ? 0 : active_index + 1;
      prev_index = active_index === 0 ? perNum : active_index - 1;
      next_index = active_index === perNum ? 0 : active_index + 1;
      dom.childNodes[active_index].className = 'active';
      dom.childNodes[prev_index].className = 'prev';
      dom.childNodes[next_index].className = 'next';
    },
    //生成随机数
    randomNum(minNum, maxNum){
      switch(arguments.length){
        case 1:
          return parseInt(Math.random()*minNum+1,10);
          break;
        case 2:
          return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10);
          break;
        default:
          return 0;
          break;
      }
    }
  },
}
</script>


<style lang="scss">
.guests-list-wrap {
  margin: 0 auto;
  position: relative;
}

.guests-list {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  list-style: none;
  padding-left: 0;

  li {
    overflow: hidden;
    position: relative;
    opacity: 1;
  }

  i {
    display: block;
    width: 100%;
    height: 100%;
    background: center / cover no-repeat;
    position: absolute;
    left: 0;
    top: 0;
    &.active {
      animation: guests-item-slider-change 1s ease-in-out;
      z-index: 100;
    }
    &.prev {
      z-index: 10;
    }
  }
}

.guests-list-more {
  a {
  }
}
//切换动画
@keyframes guests-item-slider-change {
  from {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
  to {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}

</style>

